<template>
  <div class="flex basis-full flex-col justify-between lg:basis-1/3">
    <div class="xl:max-w-xl" :class="[centered && 'flex flex-col items-center']">
      <Image
        v-if="card.image?.url"
        :url="card.image?.url"
        :alt="card.image?.alt"
        class="mb-6 aspect-square h-full overflow-hidden rounded-2xl object-cover object-center lg:mb-9 lg:aspect-[1.12]"
        width="600"
        height="600"
        sizes="xs:100vw sm:300px md:400px lg:444px xl:444px"
        fit="cover"
      />
      <div v-if="card?.title" class="mb-3.5 flex flex-col items-center px-4 lg:mb-11">
        <h2 class="mb-2 text-center font-serif text-3xl font-bold leading-snug text-black">
          {{ card.title }}
        </h2>
        <HeaderLine />
      </div>
      <div
        v-if="card?.copy"
        class="custom-list space-y-4 px-4 font-sans text-base leading-tight text-black lg:text-lg [&_ul]:text-left"
        :class="[centered && 'text-center']"
        v-html="card.copy"
      ></div>
    </div>
    <Link
      v-if="card?.link?.url"
      :title="card?.link?.title"
      :type="index > 0 ? 'outline' : 'fill'"
      :link="card?.link?.url"
      class="mt-3.5 w-full lg:mt-11 lg:w-auto"
      :class="[centered ? 'self-center' : 'self-start']"
      :external="card.link?.type === 'ext'"
    />
  </div>
</template>

<script setup lang="ts">
import HeaderLine from '../atoms/Icons/HeaderLine.vue'
import Link from '../atoms/Link.vue'
import Image from '../atoms/Image.vue'
import type { ICardData } from '../../types'

interface ICardComponent {
  card: ICardData
  index?: number
  centered?: boolean
}

withDefaults(defineProps<ICardComponent>(), {
  centered: false,
  index: 0,
})
</script>
